// import React from 'react'
import React, { useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { Tabs } from "antd";
import { TabsProps } from 'antd';
import Procurement from './Procurement';
import BusinessFinancial from './BusinessFinancial';
import BranchOffice from "../Assets/images/BranchOffice.png";
import head_Office from "../Assets/images/head_Office.png";

function TabContentOrganizational() {


    const onChange = (key) => {
      console.log(key);
    };

    const _tender_WordCount= 20;
    const _importantLinks_WordCount = 20;

    const items = [
      {
        key: '1',
        label: 'Head Office',
        // children: <marquee className="marq" height="350px" direction="up" scrollamount="4" loop=""><BusinessFinancial wordCount={_importantLinks_WordCount}/></marquee>,
        // children: <BusinessFinancial wordCount={_importantLinks_WordCount}/>,
        children: <div style={{textAlign:'center'}}><img src={`${head_Office}`} alt="Benfed"/></div>
      },
      {
        key: '2',
        label: 'Branch Office',
        // children: <marquee className="marq" height="350px" direction="up" scrollamount="4" loop=""><Procurement wordCount={_tender_WordCount}/></marquee>,
        // children: <Procurement wordCount={_tender_WordCount}/>,
        children: <div style={{textAlign:'center'}}><img src={`${BranchOffice}`} alt="Benfed"/></div>
      }
    ];
    
  return (
  <>
  
  <div className="wrapper_sm org_sec">
  <Tabs className='tabContent' defaultActiveKey="1" items={items} onChange={onChange} />
  </div>

  </>
  )
}

export default TabContentOrganizational